module.exports = __webpack_public_path__ + "img/pin6.67b11fbe.svg";